import { Button, Icon, Layout, Text } from '@loadsmart/miranda-react'

import { TrackingMethod } from '../../domain/Tracking'
import { ProvidersBadge } from './ProvidersBadge'
import { ProviderCard } from './styles'

type AssetCarrierCardContentProps = {
  readonly onClick: () => void
}

export function AssetCarrierCardContent({ onClick }: AssetCarrierCardContentProps) {
  return (
    <ProviderCard onClick={onClick} aria-labelledby="asset-carrier-label">
      <Layout.Stack gap="spacing-2">
        <Layout.Group align="center" justify="space-between">
          <Layout.Group gap="spacing-2">
            <ProvidersBadge methods={[TrackingMethod.ELD]} />
          </Layout.Group>
          <Button aria-label="Assign asset carrier" variant="icon-secondary" size="small">
            <Icon name="add-circle" size="20px" color="color-text-placeholder" />
          </Button>
        </Layout.Group>
        <Text id="asset-carrier-label" variant="body-md-bold" color="color-text-secondary">
          Add the asset carrier to complement your load info
        </Text>
        <Text variant="body-sm" color="color-text-placeholder">
          We include both the names of the asset carrier and the broker on the Bill of Lading (BOL).
        </Text>
      </Layout.Stack>
    </ProviderCard>
  )
}
